import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AdminComponent } from './admin.component'
import { AdminGuard } from './admin-guard.service'

import { UsersComponent } from './users/users.component'


const ROUTES: Routes = [
	{
		path: 'admin',
		component: AdminComponent,
		canActivate: [AdminGuard],
		children: [
			{
				path: 'users',
				component: UsersComponent,
			}
		]
	}
]

@NgModule({
	imports: [
		RouterModule.forChild(ROUTES)
	],
	exports: [
		RouterModule
	]
})

export class AdminRoutingModule { }



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/admin-routing.module.ts